import type { SVGProps } from 'react';

export function AppleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 6.6c-.33 0-.6-.27-.6-.6v-.6a3 3 0 0 1 3-3h.6c.33 0 .6.27.6.6v.6a3 3 0 0 1-3 3zm-8.4 6.6c0-2.861 1.339-6 4.2-6 1.024 0 2.239.386 3.101.724a3.05 3.05 0 0 0 2.201 0c.86-.334 2.078-.724 3.102-.724 2.861 0 4.2 3.139 4.2 6 0 4.8-3 8.4-6 8.4-.619 0-1.429-.248-1.931-.424a1.43 1.43 0 0 0-.938 0c-.502.176-1.312.424-1.931.424-3 0-6-3.6-6-8.4z" />
    </svg>
  );
}
